import { createContext, useContext } from "react";

/**
 * True for a page rendered inside a route drawer. Page chrome (Layout,
 * breadcrumbs, settings navigation) steps aside so only the form shows.
 */
export const RouteDrawerContext = createContext(false);

export const useInRouteDrawer = () => useContext(RouteDrawerContext);

/** Keeps detail actions visible while the shared sheet supplies page chrome. */
export const RouteDetailContext = createContext(false);
export const useInRouteDetail = () => useContext(RouteDetailContext);
